
<ng-container *ngIf="(storeService.vm$ | async) as vm">
  <!--
  <h3 id="parent-guardian-information">{{metadata.attributes.HEADING}}</h3>
  <div class="detail" [innerHTML]="metadata.attributes.DESCRIPTION"></div>
  -->

    <h3 id="parentGuardian">Parent/Guardian 1</h3>
    <subcomponent
      #parentGuardian1
      [parentMetadata]="metadata"
      name="PARENT_GUARDIAN1"
    ></subcomponent>

    <hr style="border-top: 1px solid #e1e1e1"/>

    <h3 id="parentGuardian">Parent/Guardian 2</h3>

    <div>
      <input
        id="populateParentGuardian2"
        type="checkbox"
        name="populateParentGuardian2"
        [ngModel]="vm.populateParentGuardian2"
        (ngModelChange)="storeService.updateState({ populateParentGuardian2: $event })"
        #populateParentGuardian2="ngModel">
      <label for="populateParentGuardian2" class="d-inline">
        Provide Parent/Guardian 2 Information?
      </label>
    </div>

    <subcomponent
      *ngIf="shouldShowParentGuardian2"
      #parentGuardian2
      [parentMetadata]="metadata"
      name="PARENT_GUARDIAN2"
    ></subcomponent>

    <hr style="border-top: 1px solid #e1e1e1"/>

</ng-container>
